import React from 'react';
import ReactDOM from 'react-dom/client';
import Principal from './Principal';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Principal />
  </React.StrictMode>
);

reportWebVitals();
